import React, { useState, useEffect } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import FiltersPartial from './FiltersPartial.js';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import PageContentWrapper from "../../components/PageContentWrapper";
import Modal from 'react-bootstrap/Modal';
import { selectQueryParams, updateQueryParams, resetQueryParams } from "../../ui/customerListingReducer.js";
import { useSelector, useDispatch } from "react-redux";

const FinalizeModal = (props) => {
  const [ finalizePartnerBillApi ] = getApi('finalizePartnerBill')
  const dispatch = useDispatch()
  const selectedQueryParams = useSelector(selectQueryParams)

  const onFinalizeClick = async () => {
    try {
      const response = await finalizePartnerBillApi({ bill_id: props.updateDetails?.id, user_id: props.updateDetails?.user_id }).unwrap();
      props.updateShowState()
      toast.success("Partner bill finalized successfully")
      dispatch(updateQueryParams(selectedQueryParams));
    } catch (error) {
      toast.error("Partner bill not finalized")
    }
  }
  

  return <Modal show={props.updateDetails !== null} onHide={() => props.updateShowState()}>
    <Modal.Header closeButton>
      <Modal.Title>Are you sure?</Modal.Title>
    </Modal.Header>
    <Modal.Body className="h6"> <b>You are finalizing the bill for partner CP{`${props.updateDetails?.user_id}`}  
      {props.updateDetails?.user_name} for the Rs.{props.updateDetails?.unpaid_amount}</b> <br/>
    </Modal.Body>
    <Modal.Footer>
      <button className='btn bg-danger text-white' onClick={()=> props.updateShowState()}>
        Close
      </button>
      <button className='btn bg-success text-white' onClick={onFinalizeClick}>
        Finalize Bill
      </button>
    </Modal.Footer>
  </Modal>
}

export default FinalizeModal;
